<div class="form-card">
    <div class="">
      <div class="d-flex justify-content-start align-items-center">
        <a [href]="routerLink">
          <img [src]="image" alt="image">
        </a>
      </div>
      <div class="form-card-header py-3 text-start">
        <span>{{ formTitle }}</span>
      </div>
      <span class="subTitle">{{subTitle}}</span>
      <br/>
      <ng-content></ng-content>
    </div>
</div>